import React from "react";
import {CCard, CCardBody, CCardFooter, CCardHeader, CCol, CForm, CRow} from "@coreui/react";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import {getCheckTgAuthOptions} from "./CheckForm.model";
import RulesCard from "../../../components/RulesComponents/RulesCard";
import {useTranslation} from "react-i18next";
import {checkTypes} from "../Checks.model";
import {CHECK_TYPES, REG_EXS} from "../../../utils/constants";
import FormControlsButtons from "../../../components/FormControlButtons";
import {MESSAGES} from "../../../components/ReactHookForm/schemes/messages";
import {ACTIONS, getProjectRole, hasGlobalPermission, hasProjectPermission} from "../../../utils/user-access";
import {useSelector} from "react-redux";
import {telegramTokenIsSetSelector} from "../../../store/selectors/global";
import {ARInputWithLabel, ARSelectWithLabel, ARTextareaWithLabel} from "../../../components/ReactHookForm/fields";

const CheckForm = (props) => {
  const {
    header,
    handleSubmit,
    onFormReset,
    onFormSubmit,
    control,
    Prompt,
    setFormError,
    formId,
    formClassName,
    isAddMode,
    rules,
    isProjectAdmin,
    onTimeoutChange,
    onDownTimeoutChange,
    onTypeChange,
    options,
    typeValue
  } = props;
  const projectRole = getProjectRole(isProjectAdmin);
  const isTelegramTokenSet = useSelector(telegramTokenIsSetSelector);
  const isProjectFieldDisplay = isAddMode || hasGlobalPermission(ACTIONS.CHANGE_CHECK_PROJECT);
  const {t} = useTranslation();

  const {timeoutsOptions, downTimeoutsOptions, integrationsOptions, projectsOptions} = options;

  const {rulesInfo, RuleActions, requiredData} = rules;

  const isJiraCheck = typeValue === CHECK_TYPES.JIRA;
  const isPingCheck = typeValue === CHECK_TYPES.PING;
  const isHttpCertCheck = typeValue === CHECK_TYPES.HTTP_CERTIFICATE;
  const isDomainCheck = typeValue === CHECK_TYPES.DOMAIN;
  const isBalanceCheck = typeValue === CHECK_TYPES.BALANCE;
  const isHeaderCheck = typeValue === CHECK_TYPES.HEADER;
  const isPortCheck = typeValue === CHECK_TYPES.PORT;
  const isHttpCheck = typeValue === CHECK_TYPES.HTTP;
  const isExternalCheck = typeValue === CHECK_TYPES.EXTERNAL;

  return (
    <>
      <CCard>
        <Prompt/>
        <CCardHeader>
          <h1 className="card-header-text">{header}</h1>
        </CCardHeader>
        <CCardBody>
          <CForm
            onSubmit={handleSubmit(onFormSubmit)}
            id={formId}
            className={formClassName}
          >
            <ARInputWithLabel
              id="name"
              name="name"
              labelText={t("form:label.checkName", "Check name")}
              placeholder={t("form:placeholder.checkName", "Enter check's name")}
              control={control}
              disabled={isExternalCheck}
              autoComplete="off"
            />
            {
              !isExternalCheck &&
              <ARTextareaWithLabel
                id="description"
                name="description"
                labelText={t("form:label.description", "Description")}
                labelColClassName="form-textarea-label"
                placeholder={t("form:placeholder.description", "Enter description")}
                className="textarea-size"
                control={control}
                autoComplete="off"
              />
            }
            <ARSelectWithLabel
              id="type"
              name="type"
              labelText={t("form:label.checkType", "Check type")}
              control={control}
              onSelectChange={onTypeChange}
              options={isExternalCheck ? checkTypes : checkTypes.filter((checkType) => checkType.isUsed)}
              disabled={isExternalCheck}
            />
            {
              !isExternalCheck &&
              <>
                {
                  isHttpCheck &&
                  <ARInputWithLabel
                    id="url"
                    name="url"
                    labelText={t("form:label.url", "Url")}
                    placeholder={t("form:placeholder.url", "Enter url")}
                    control={control}
                    autoComplete="off"
                  />
                }
                {
                  isHeaderCheck &&
                  <>
                    <ARInputWithLabel
                      id="url"
                      name="url"
                      labelText={t("form:label.url", "Url")}
                      placeholder={t("form:placeholder.url", "Enter url")}
                      control={control}
                      autoComplete="off"
                    />
                    <ARInputWithLabel
                      id="extra.header"
                      name="extra.header"
                      labelText={t("form:label.headerName", "Header name")}
                      placeholder={t("form:placeholder.headerName", "Enter header name")}
                      control={control}
                      autoComplete="off"
                    />
                    <ARInputWithLabel
                      id="extra.text"
                      name="extra.text"
                      labelText={t("form:label.text", "Text")}
                      placeholder={t("form:placeholder.text", "Enter text")}
                      control={control}
                      autoComplete="off"
                    />
                  </>
                }
                {
                  isPingCheck &&
                  <ARInputWithLabel
                    id="url"
                    name="url"
                    labelText={t("form:label.domain", "Domain")}
                    placeholder={t("form:placeholder.domain", "Enter domain")}
                    control={control}
                    autoComplete="off"
                  />
                }
                {
                  isHttpCertCheck &&
                  <ARInputWithLabel
                    id="url"
                    name="url"
                    labelText={t("form:label.domain", "Domain")}
                    placeholder={t("form:placeholder.domain", "Enter domain")}
                    control={control}
                    autoComplete="off"
                  />
                }
                {
                  isDomainCheck &&
                  <ARInputWithLabel
                    id="url"
                    name="url"
                    labelText={t("form:label.domain", "Domain")}
                    placeholder={t("form:placeholder.domain", "Enter domain")}
                    control={control}
                    autoComplete="off"
                  />
                }
                {
                  isJiraCheck &&
                  <>
                    <ARSelectWithLabel
                      id="integration"
                      name="integration"
                      labelText={t("form:label.integration", "Integration")}
                      control={control}
                      setError={setFormError}
                      highlightInvalid
                      options={integrationsOptions}
                    />
                    <ARInputWithLabel
                      id="url"
                      name="url"
                      labelText={t("form:label.filter", "Filter")}
                      placeholder={t("form:placeholder.filter", "Enter filter")}
                      control={control}
                      autoComplete="off"
                    />
                  </>
                }
                {
                  isBalanceCheck &&
                  <>
                    <ARSelectWithLabel
                      id="integration"
                      name="integration"
                      labelText={t("form:label.integration", "Integration")}
                      control={control}
                      setError={setFormError}
                      highlightInvalid
                      options={integrationsOptions}
                    />
                    <ARInputWithLabel
                      id="balance_threshold"
                      name="balance_threshold"
                      type="tel"
                      labelText={t("form:label.balance", "Balance threshold")}
                      placeholder={t("form:placeholder.balance", "Enter balance threshold")}
                      control={control}
                      setFormError={setFormError}
                      autoComplete="off"
                      pattern={REG_EXS.BALANCE_CHARACTERS}
                      patternMismatchMessage={MESSAGES.BALANCE_CHARACTERS_ONLY}
                    />
                  </>
                }
                {
                  isPortCheck &&
                  <>
                    <ARInputWithLabel
                      id="url"
                      name="url"
                      labelText={t("form:label.domain", "Domain")}
                      placeholder={t("form:placeholder.domain", "Enter domain")}
                      control={control}
                      autoComplete="off"
                    />
                    <ARInputWithLabel
                      id="port"
                      name="port"
                      labelText={t("form:label.port", "Port")}
                      placeholder={t("form:placeholder.port", "Enter port")}
                      type="tel"
                      control={control}
                      setFormError={setFormError}
                      autoComplete="off"
                      pattern={REG_EXS.DIGITS_CHARACTERS}
                      patternMismatchMessage={MESSAGES.DIGITS_ONLY}
                    />
                  </>
                }
                <ARSelectWithLabel
                  id="timeout"
                  name="timeout"
                  labelText={t("form:label.timeout", "Timeout")}
                  control={control}
                  onSelectChange={onTimeoutChange}
                  options={timeoutsOptions}
                />
                <ARSelectWithLabel
                  id="down_timeout"
                  name="down_timeout"
                  labelText={t("form:label.downTimeout", "Down timeout")}
                  control={control}
                  onSelectChange={onDownTimeoutChange}
                  options={downTimeoutsOptions}
                />
                {
                  isTelegramTokenSet &&
                  <ARSelectWithLabel
                    id="is_telegram_auth_enabled"
                    name="is_telegram_auth_enabled"
                    labelText={t("form:label.checkTelegramAuth.label", "Telegram authorization")}
                    control={control}
                    options={getCheckTgAuthOptions()}
                  />
                }
                {
                  isProjectFieldDisplay &&
                  <ARSelectWithLabel
                    id="project"
                    name="project"
                    labelText={t("form:label.project", "Project")}
                    control={control}
                    options={projectsOptions}
                  />
                }
              </>
            }
          </CForm>
        </CCardBody>
        <CCardFooter>
          <FormControlsButtons
            form={formId}
            disabled={isExternalCheck}
            onCancelClick={onFormReset}
          />
        </CCardFooter>
      </CCard>
      {
        !isAddMode && hasProjectPermission(ACTIONS.VIEW_CHECKS_RULES, projectRole) &&
        <CCard>
          <CCardBody>
            <CRow>
              <CCol>
                <RulesCard
                  className="mt-2"
                  rules={rulesInfo}
                  deleteRule={RuleActions.deleteRule}
                  updateRule={RuleActions.updateRule}
                  members={requiredData.members}
                  telegramChats={requiredData.telegramChats}
                  showRuleAddButton={hasProjectPermission(ACTIONS.CREATE_CHECKS_RULES, projectRole)}
                  showRuleSwitcher={hasProjectPermission(ACTIONS.ENABLE_DISABLE_CHECKS_RULES, projectRole)}
                  showEditButton={hasProjectPermission(ACTIONS.EDIT_CHECKS_RULES, projectRole)}
                  showDeleteButton={hasProjectPermission(ACTIONS.DELETE_CHECKS_RULES, projectRole)}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      }
    </>
  );
};

export default withErrorBoundary(CheckForm);